<template>

  <v-dialog
      ref="dialog1"
      v-model="modal1"
      :return-value.sync="date"
      persistent
      width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="computedDate"
          :label="label"
          prepend-icon="mdi-calendar"
          :clearable="clearable"
          :disabled="disabled"
          :clear-icon-cb="onClearClicked"
          readonly
          v-bind="attrs"
          v-on="on"
          style="
                  margin: 0 auto;
                  width: 350px;"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        color="pink"
        scrollable
        locale="de-de"
        :first-day-of-week="1"
    >
      <v-spacer></v-spacer>
      <v-btn
          text
          color="pink"
          @click="modal1 = false"
      >
        Abbrechen
      </v-btn>
      <v-btn
          text
          color="pink"
          @click="$refs.dialog1.save(date)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>

</template>

<script>
export default {
  name: "DialogDate",

  data () {
    return {

      modal1: '',
      date: '',

    }
  },

  created() {

    if(this.initial_date != ""){
      this.date = this.$moment(this.initial_date, "DD.MM.YYYY").format("YYYY-MM-DD")
    }

  },

  methods:{

    onClearClicked(){
      console.log("onClearClicked")
    this.date = ""
    }

  },


  watch:{

    initial_date(){
      this.date = this.$moment(this.initial_date, "DD.MM.YYYY").format("YYYY-MM-DD")
    },

    date(){
      console.log("date")
      console.log(this.date)
    }


  },


  computed: {
    computedDate: {
      get()
      {
        console.log(this.date)

        if (this.date == null) {
          console.log("date == Null")
          this.$emit('input', "")
          return
        }

        if (this.date == "" || this.date == "Invalid date") {
          console.log("date == Null")
          this.$emit('input', "")
          return
        }

        this.$emit('input', this.$moment(this.date, "YYYY-MM-DD").format("DD.MM.YYYY"))
        return this.$moment(this.date, "YYYY-MM-DD").format("DD.MM.YYYY")
      },
      set(newValue) {
        // Note: we are using destructuring assignment syntax here.
        console.log("set: " + newValue)
        this.date = newValue
      }


    },
  },


  props:{

    initial_date:{
      type: String,
      default: null,
    },

    label:{
      type: String,
      default: "Datum"
    },

    clearable:{
      type: Boolean,
      default: false
    },

    disabled:{
      type: Boolean,
      default: false
    }



  },

  model: {
    prop: 'value',
    event: 'input'
  },



}
</script>

<style scoped>

</style>
